<template>
	<v-container fluid>
		<div class="bottom-buttons-outer">
			<v-btn color="success" @click="backClick">
				<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
			</v-btn>
			<v-btn color="success" @click="saveClick">
				<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
			</v-btn>
		</div>
		<v-layout row wrap>
			<v-flex lg8 xs12>
				<v-card>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12>
								<InputField v-model="partner.first_name"
											:error="partnerValidation.first_name"
											:label="'* '+$t('fields.firstName')"></InputField>
							</v-flex>
							<v-flex xs12>
								<InputField
									v-model="partner.last_name"
									:error="partnerValidation.last_name"
									:label="'* '+$t('fields.lastName')"></InputField>
							</v-flex>
							<v-flex xs12>
								<InputField
									v-model="partner.username"
									:error="partnerValidation.username"
									:label="'* '+$t('fields.username')"></InputField>
							</v-flex>
							<v-flex xs12>
								<InputField
									:readonly="partner.id!=0"
									v-model="partner.email"
									:error="partnerValidation.email"
									:label="'* '+$t('fields.email')"></InputField>
							</v-flex>
							<v-flex xs12 v-if="partner.id != 0">
								<CheckBox
									:label="$t('fields.passwordChange')"
									v-model="partner.password_change"></CheckBox>
							</v-flex>
							<v-flex v-if="partner.id == 0 || partner.password_change" xs12>
								<InputField
									v-model="partner.password"
									:error="partnerValidation.password"
									:label="'* '+$t('fields.password')"></InputField>
							</v-flex>
							<v-flex xs12 md6 pr-1>
								<Dropdown
									v-model="partner.language_id"
									:error="partnerValidation.language_id"
									:ajax="true"
									:data="'languages'"
									:label="'* '+$t('fields.mainLanguage')"></Dropdown>
							</v-flex>
							<v-flex xs12 md6 pl-1>
								<DropdownMultiple
									v-model="partner.other_languages"
									:error="partnerValidation.other_languages"
									:ajax="true"
									:data="'languages'"
									:label="$t('fields.otherLanguages')"></DropdownMultiple>
							</v-flex>
							<v-flex xs12>
								<CheckBox
									v-model="partner.active"
									:label="$t('fields.active')"></CheckBox>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import InputField from "./trinkets/InputField"
import CheckBox from "./trinkets/CheckBox";
import Dropdown from "./trinkets/Dropdown";
import DropdownMultiple from "./trinkets/DropdownMultiple";
import Partner from "../models/Partner";

export default {
	name: "Partner",
	components: {CheckBox, InputField, Dropdown, DropdownMultiple},
	data: function () {
		return {
			partner: new Partner({id: this.$route.params.id}),
			partnerValidation: {
				id: '',
				first_name: '',
				last_name: '',
				username: '',
				email: '',
				password: '',
				partner_role_id: '',
				active: '',
				language_id: '',
				languages: ''
			},
			initialLoad: false,
			changesHappened: false
		}
	},
	watch: {
		partner: {
			handler: function () {
				if (this.initialLoad) {
					this.changesHappened = true;
				}
			},
			deep: true
		},
	},
	methods: {
		backClick() {
			this.$router.go(-1);
		},
		saveClick() {
			let success = true;

			if (this.partner.first_name == '') {
				success = false;
				this.partnerValidation.first_name = this.$t('alerts.fieldError');
			} else {
				this.partnerValidation.first_name = '';
			}

			if (this.partner.last_name == '') {
				success = false;
				this.partnerValidation.last_name = this.$t('alerts.fieldError');
			} else {
				this.partnerValidation.last_name = '';
			}

			if (this.partner.username == '') {
				success = false;
				this.partnerValidation.username = this.$t('alerts.fieldError');
			} else {
				this.partnerValidation.username = '';
			}

			if (this.partner.language_id == null) {
				success = false;
				this.partnerValidation.language_id = this.$t('alerts.fieldError');
			} else {
				this.partnerValidation.language_id = '';
			}

			if (this.partner.id == 0 || this.partner.password_change) {
				if (this.partner.password.trim() == '') {
					success = false;
					this.partnerValidation.password = this.$t('alerts.fieldError');
				} else {
					if (this.partner.password.length < 8) {
						success = false;
						this.partnerValidation.password = this.$t('alerts.passwordLength');
					} else {
						this.partnerValidation.password = '';
					}
				}
			}

			if (this.partner.email == '') {
				success = false;
				this.partnerValidation.email = this.$t('alerts.fieldError');
			} else {
				if (!this.$checkEmail(this.partner.email)) {
					success = false;
					this.partnerValidation.email = this.$t('alerts.emailFailFormat');
				} else {
					this.partnerValidation.email = '';
				}
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				if (vm.partner.id != 0) {
					action = 'put';
					addition = '/' + vm.partner.id;
				}
				this.$APICall(action, 'partners' + addition, this.partner, (data, success) => {
					if (success) {
						vm.changesHappened = false;
						if (vm.partner.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						vm.backClick();
					} else {
						if (data.internal_message == 'User with that email address already exists') {
							vm.$alert(vm.$t('alerts.partnerExists'));
						} else if (data.message.includes('User with that email address already exists')) {
							vm.$alert(vm.$t('alerts.partnerExists'));
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					}
				});
			}
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		let vm = this;
		if (this.partner.id != 0) {
			this.$APICall('get', 'partners/' + this.partner.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.$myStore.commit('setBreadcrumbs', [
						{text: vm.$t('modules.partners'), href: '/#/partners', disabled: false},
						{text: vm.partner.email, href: '/#/partners/' + vm.partner.id, disabled: true}
					]);
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
					usableData.password_change = false;
					vm.partner = usableData;
				}
			});
		} else {
			this.$myStore.commit('setBreadcrumbs', [
				{text: this.$t('modules.partners'), href: '/#/partners', disabled: false},
				{text: this.$t('modules.newPartner'), href: '/#/partners/0', disabled: true}
			]);
			this.initialLoad = true;
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.changesHappened) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				next(result);
			});
		} else {
			next(true);
		}
	}
}
</script>

<style scoped>

</style>
